import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pl';
    document.title = 'RELIGIA GOTOWA™ – Cały rok religii gotowy dla katechety';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihv1ac76whht">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ml17jjuay8oa">
        <InfoBar data-id="element-2" data-mp="3rbr9so7flver" />
        <main data-id="element-3" data-mp="3rdaquh0wwahl">
          <Hero data-id="element-4" data-mp="3rdkl4gszp3t3" />
          <StatsBar data-id="element-5" data-mp="3rd18nfm3z7mg" />
          <Difference data-id="element-6" data-mp="5yk6vxnnffx" />
          <Recognize data-id="element-7" data-mp="6hovayao7c0" />
          <WhatsInside data-id="element-8" data-mp="4wylxj0jajy" />
          <InsidePages data-id="element-9" data-mp="56m9egl55mh" />
          <Bonuses data-id="element-10" data-mp="2zl3a7gleoy37" />
          <HowItWorks data-id="element-11" data-mp="2zllen0i82im7" />
          <Audience data-id="element-12" data-mp="2zm4v0cs84yy4" />
          <Offer data-id="element-13" data-mp="2zmwi0z7r9ocs" />
          <Guarantee data-id="element-14" data-mp="2zng14j956ise" />
          <Faq data-id="element-15" data-mp="33mf1rrnubte1" />
          <FinalCta data-id="element-16" data-mp="33lwywc6oagx5" />
        </main>
        <Footer data-id="element-17" data-mp="33mym1f0yqtv8" />
      </div>
    </MotionConfig>;
}